var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-main-detail"},[_c('div',{staticClass:"container"},[_c('order-detail-meta',{attrs:{"id":_vm.id,"mode":"my"}}),_c('md-button',{staticClass:"md-icon-button close back",on:{"click":_vm.goback}},[_c('md-icon',[_vm._v("keyboard_backspace")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }